<template>
	<div>
		<el-card shadow="never">
			<el-row :gutter="10">
				<el-col :span="3">
					<div class="Schleft">
						<el-select
					    	v-model="SchType" 
					    	placeholder="预警级别">
					        <el-option label="一般" value="0"></el-option>
					        <el-option label="较重" value="1"></el-option>
					        <el-option label="严重" value="2"></el-option>
					        <el-option label="紧急" value="3"></el-option>
					        <el-option label="全部" value="4"></el-option>
					    </el-select>
					</div>
				</el-col>
				<el-col :span="5">
				    <el-autocomplete
						popper-class="my-autocomplete"
						v-model="OperatorName"
						:fetch-suggestions="queryAdd"
						class="Schleft"
						@select="handleAdd"
						placeholder="请输入运营商名称查询">
					    <template slot-scope="{ item }">
					    	<div class="name">{{ item.OperatorName }}</div>
					    </template>
					</el-autocomplete>
				</el-col>
				<el-col :span="16">
					<el-button 
						:loading="status.sch" 
						type="primary" 
						@click="RechargeSch('Sch')" 
						icon="el-icon-search">
					</el-button>
				</el-col>
			</el-row>

			<el-table :data="DataList" v-loading="status.sch" style="width: 100%;" :height="BoxHeight" border>
			    <el-table-column label="#" prop="Seq">
				    <template slot-scope="scope">
				        <div class="ReSeq">{{ scope.row.Seq }}</div>
				    </template>
			    </el-table-column>
			    <el-table-column label="电站名称" prop="StationName">
			        <template slot-scope="scope">
			        	<div class="ReSeq">{{ scope.row.StationName }}</div>
			        </template>
			    </el-table-column>
			    <el-table-column label="设备ID" prop="EquipmentID">
			        <template slot-scope="scope">
			        	<div class="ReSeq">{{ scope.row.EquipmentID }}</div>
			        </template>
			    </el-table-column>
			    <el-table-column label="预警内容" prop="Content">
			        <template slot-scope="scope">
			        	<div class="ReSeq">{{ scope.row.Content }}</div>
			        </template>
			    </el-table-column>
			    <el-table-column label="预警级别" prop="WarningLevel">
			      <template slot-scope="scope">
			      	<el-tag v-if="scope.row.WarningLevel===0" type="warning" effect="plain">一般</el-tag>
		          	<el-tag v-else-if="scope.row.WarningLevel===1" type="warning" effect="plain">较重</el-tag>
		          	<el-tag v-else-if="scope.row.WarningLevel===2" type="danger" effect="plain">严重</el-tag>
		          	<el-tag v-else-if="scope.row.WarningLevel===3" type="danger" effect="plain">紧急</el-tag>
		          	<el-tag v-else type="info" effect="plain">未知</el-tag>
			      </template>
			    </el-table-column>
			</el-table>
		</el-card>
	</div>
</template>

<script>
import aucheck from '@/utils/aucheck.js';
import warning from './WarningInfo.js';
import { MessageBox, Message, Loading } from 'element-ui'
import common from '@/utils/common.js';
export default {
	name:"WarningInfo",
	created(){
		this.getfirst();
		this.getHeight();
		window.addEventListener("resize", this.getHeight);
	},
	destroyed() {
	    window.removeEventListener("resize", this.getHeight);
	},
	data(){
		return{
			BoxHeight:768,
			SchType:'4',
			OperatorID:'',
			OperatorName:'',
			status:{
				sch:false,	
			},
			DataList:[],
		}
	},
	methods:{
		//初始化；
		async getfirst(){
			if(!await aucheck.checkOf('H41')) return false;
			const that = this;
			warning.getusertype().then(res=>{
				if(res) {
					that.OperatorID   = res.AccountInfo.OperatorID;
					that.OperatorName = res.AccountInfo.OperatorName;
				}
			});
			that.RechargeSch('');
		},
		async RechargeSch(type){
			if(!await aucheck.check('H41')) return false;
			const that = this;
			that.status.sch = true;

			const res = await warning.schSend(that.SchType ,that.OperatorID);
			if(res) that.DataList = res;
			that.status.sch = false;
		},

		//查询-搜索运营商；
		async queryAdd(queryString, cb) {
			let str      = queryString.replace(/(^\s*)|(\s*$)/g, '');
			var result   = [];

	        if(str.length>1){
	        	let res = await common.GetOperator(str);
	        	if(res) result = res;
	        }	
        	cb(result);
	    },
	    //查询-选择运营商；
	    handleAdd(item){
	    	this.OperatorName = item.OperatorName;
	    	this.OperatorID   = item.OperatorID;
	    },
		getHeight() {
			this.BoxHeight = window.innerHeight-206;
    	}
	}
}


</script>

<style scoped>
.el-table{
	margin-top:20px;
	font-size:12px;
}
.Schleft .el-select{
	width:100%;
}
.Schcontent .el-input{
	width:50%;
}
.Schcontent .selbtn{
	margin-left:10px;
}
.ReSeq{
	width:100%;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}
.ReSeq:hover{
	text-overflow:inherit; 
    overflow: visible; 
    white-space: pre-line;
}
.el-autocomplete{
	width: 100%;
}
</style>
